<div class="grid grid-cols-2 justify-between gap-4 md:grid md:justify-between">
  <h2
    class="translate-y-[4px] text-nowrap text-2xl font-extrabold leading-[1.3125rem] text-mango-black17"
  >
    Partners
  </h2>

  <button
    *appHasPermission="'can_create_partner'"
    type="button"
    mango-button
    routerLink="/admin/partners/add-partner"
    class="w-fit justify-self-end text-nowrap"
  >
    + Add Partner
  </button>
</div>

<div
  *appHasPermission="'can_get_partner'"
  class="mt-[0.94rem] grid gap-5 lg:grid-cols-3"
>
  <div class="rounded-md bg-[#EEF4FF] p-[38px] shadow-sm">
    <div>
      <p>Total Partners</p>
    </div>
    <div>
      <h1 class="number-stat-font text-4xl">
        {{ totalCount$ | async | number }}
      </h1>
    </div>
  </div>

  <div class="rounded-md bg-[#FFF6E8] p-[38px] shadow-sm">
    <div>
      <p>Total Subs</p>
    </div>
    <div>
      <h1 class="number-stat-font text-4xl">{{ totalSubs | number }}</h1>
    </div>
  </div>

  <div class="rounded-md bg-[#E5FFE6] p-[38px] shadow-sm">
    <div>
      <p>Total Active Subs</p>
    </div>
    <div>
      <h1 class="number-stat-font text-4xl">{{ totalActiveSubs | number }}</h1>
    </div>
  </div>
</div>

<div *appHasPermission="'can_get_partner'" class="flex gap-3">
  <app-filters [filters]="filterStructure"></app-filters>
  <app-table-refresh class="mt-5" [tableKey]="'partners'"></app-table-refresh>
</div>

<!-- Partners Table -->
<div
  *appHasPermission="'can_get_partner'"
  class="mt-[0.94rem] rounded-lg border border-solid border-mango-gray200 bg-white"
>
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <div
        class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        @if (isFetchingPartners$ | async) {
          <app-table-skeleton-loader></app-table-skeleton-loader>
        } @else {
          <table class="min-w-full leading-normal">
            <thead>
              <tr>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
                >
                  S/N
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
                >
                  Partner
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
                >
                  Email
                </th>
                <th
                  class="border-b-2 border-gray-200 bg-gray-100 px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
                >
                  Date Added
                </th>
                <th
                  scope="col"
                  class="relative border-b-2 border-gray-200 bg-gray-100 py-3.5 pl-3 pr-4 sm:pr-6"
                >
                  <span class="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (
                partner of partnersList$ | async;
                track partner.id;
                let i = $index
              ) {
                <tr>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p>{{ i + 1 }}</p>
                  </td>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ partner.name | titlecase }}
                    </p>
                  </td>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ partner.email }}
                    </p>
                  </td>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ (partner.created_at | date: 'dd MMM, yyyy') || '-' }}
                    </p>
                  </td>
                  <td
                    class="relative whitespace-nowrap border-b py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                  >
                    <div
                      class="relative inline-block w-fit cursor-pointer border-gray-200 bg-white text-left"
                    >
                      <app-dropdown
                        [id]="partner.id"
                        [actionList]="initDropdownList(partner)"
                      >
                      </app-dropdown>
                    </div>
                  </td>
                </tr>
              } @empty {
                <tr>
                  <td
                    colspan="5"
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm text-gray-500"
                  >
                    No partners found!
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }

        <app-table-navigator
          [total]="(totalCount$ | async) || 0"
          (onNavigation)="navigate($event)"
        ></app-table-navigator>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
